<template>
  <div class="proxyhttp">
    <banner :swiperData="swiperData" :pagination="false" />
    <div class="main">
      <tabs :tabsList="tabsList" />
      <div
        class="tabs-content width1534"
        :style="{ 'border-color': tabsList[active].color }"
      >
        <http :active="active" />
      </div>
    </div>
  </div>
</template>

<script>
import banner from "@/components/banner";
import tabs from "@/components/tabs";
import http from "@/components/superhttp/index";
export default {
  name: "superhttp",
  components: { banner, tabs, http },
  data() {
    return {
      swiperData: [
        {
          title: "多贝云超级HTTP隧道代理",
          content: "IP 资源来源于全国各地的真实家宽用户",
          descript: ["全新的IP池，总的IP池子有五百万", "摆脱套餐、IP时效的约束，从使用上具有更高的灵活性", "可针对用户不同的需求进行全方位的企业级定制化"],
          btn: [
            {
              icon: require("@/assets/images/banner_icon1.png"),
              text: "免费咨询",
            },
            {
              icon: require("@/assets/images/banner_icon2.png"),
              text: "立刻试用",
            },
          ],
          imgUrl: require("@/assets/images/banner3.png"),
          mimgUrl: require("@/assets/images/mbanner3.jpg"),
        },
      ],
      tabsList: [
        {
          color: "#27a7e7",
          title: "产品简介",
          en: "Product Introduction",
          icon: require("@/assets/images/icon5.png"),
          icon_active: require("@/assets/images/icon1.png"),
        },
        {
          color: "#f78834",
          title: "产品购买",
          en: "Package purchase",
          icon: require("@/assets/images/icon6.png"),
          icon_active: require("@/assets/images/icon2.png"),
        },
        {
          color: "#1da83b",
          title: "使用指南",
          en: "Usage Guidelines",
          icon: require("@/assets/images/icon7.png"),
          icon_active: require("@/assets/images/icon3.png"),
        },
        {
          color: "#004cba",
          title: "常见问题",
          en: "frequently asked question",
          icon: require("@/assets/images/icon8.png"),
          icon_active: require("@/assets/images/icon4.png"),
        },
      ],
      active: 0,
    };
  },
  created() {
    this.$bus.$on("tabsEvent", (res) => {
      this.active = res;
    });
  },
};
</script>

<style lang="less" scoped>
.proxyhttp {
  .main {
    margin: 56px 0 110px;
  }
  .tabs-content {
    border: 9px solid transparent;
  }
}
@media (max-width: 1024px) {
  .proxyhttp .tabs-content {
    border: 4px solid transparent;
  }
}
</style>
